import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { googleSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const finish = () => {
      window.history.replaceState(null, "", "/history");
    };

    if (!sessionId) {
      navigate("/login");
      return;
    }

    googleSession(sessionId)
      .then((me) => {
        setUser(me);
        const resume = localStorage.getItem("ct_pending_prompt");
        window.history.replaceState(null, "", resume ? "/" : "/history");
        toast.success("Signed in with Google.");
        navigate(resume ? "/" : "/history");
      })
      .catch(() => {
        finish();
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login");
      });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-neon-cyan font-mono text-sm gap-3">
      <Loader2 className="animate-spin" size={18} /> Signing you in...
    </div>
  );
}
